import { component, Component, property } from '../../../concepts/objects';

const spinnerItemDef = {
    name: 'SpinnerItem',
};

@component(spinnerItemDef)
export class SpinnerItem extends Component {

    @property({ type: 'string' })
    public text: string;

    @property({ type: 'boolean' })
    public hidden: boolean;

}
